// extracted by mini-css-extract-plugin
export var limitWidthOnLargeScreens = "index-module--limitWidthOnLargeScreens--DMp+Y";
export var links = "index-module--links--Bxp2P";
export var wrapper = "index-module--wrapper--5aQB9";